import React from "react"
import { Link } from "gatsby"

import Layout from "../components/common/layout"
import SEO from "../components/common/seo"

const GUMMYSEARCH_URL =
  "https://gummysearch.com/?ref=thehiveindex.com&utm_source=thehiveindex.com"

const GummysearchIntegrationPage = () => (
  <Layout pageTitle="GummySearch integration">
    <SEO
      title="GummySearch integration | Hive Index"
      description="How Hive Index uses GummySearch data to show accurate, up-to-date stats and conversation analysis for Reddit communities listed on the site."
      path="/gummysearch-integration/"
    />

    <div className="max-w-3xl">
      <p className="text-gray-600 leading-relaxed">
        Hive Index is built to help you find and compare online communities
        across platforms. For Reddit communities specifically, we work with{" "}
        <a
          href={GUMMYSEARCH_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="text-rose-600 hover:underline"
        >
          GummySearch
        </a>{" "}
        to keep stats and analysis fresh.
      </p>

      <h2 className="mt-8 mb-3 text-xl font-bold text-gray-900">
        What Hive Index is best at
      </h2>
      <p className="text-gray-600 leading-relaxed">
        We focus on the big picture across the whole community landscape: which
        platforms communities use, what features they offer (forums, events,
        jobs, paid tiers, and more), how they are organized by topic, and what
        real members say in reviews. If you want to browse, compare, or discover
        communities on Slack, Discord, Reddit, independent sites, and elsewhere,
        Hive Index is the most complete resource we know of for that kind of
        cross-platform view.
      </p>

      <h2 className="mt-8 mb-3 text-xl font-bold text-gray-900">
        What GummySearch is best at
      </h2>
      <p className="text-gray-600 leading-relaxed">
        GummySearch is a Reddit research tool that tracks and analyzes more than
        60,000 subreddits. It aggregates Reddit data over time and turns it into
        something useful: member counts, growth trends, popular themes in
        discussions, common topics, flair usage, and product mentions. For
        understanding what is actually happening inside a subreddit, GummySearch
        is one of the most trusted sources out there.
      </p>

      <h2 className="mt-8 mb-3 text-xl font-bold text-gray-900">
        How we use it together
      </h2>
      <p className="text-gray-600 leading-relaxed">
        For Reddit communities listed on Hive Index, we pull selected data from
        GummySearch so you see accurate, updated information on the community
        page. That includes member counts, growth charts, and a breakdown of the
        kinds of conversations happening in the subreddit. We still handle
        everything else ourselves: the listing, topics, features, reviews, and
        links to join.
      </p>
      <p className="mt-3 text-gray-600 leading-relaxed">
        GummySearch goes deep on Reddit. Hive Index goes wide across platforms.
        Pairing the two means you get a community directory that is useful for
        discovery and comparison, plus Reddit-specific analysis that stays
        current without us trying to rebuild what GummySearch already does well.
      </p>

      <h2 className="mt-8 mb-3 text-xl font-bold text-gray-900">
        Explore GummySearch
      </h2>
      <p className="text-gray-600 leading-relaxed">
        If you want to dig into a subreddit beyond what we show on Hive Index,{" "}
        <a
          href={GUMMYSEARCH_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="text-rose-600 hover:underline"
        >
          visit GummySearch
        </a>
        . Community pages here also link out to the full subreddit analysis on
        their site when available.
      </p>

      <p className="mt-8 text-sm text-gray-500">
        Back to{" "}
        <Link to="/about/" className="text-rose-600 hover:underline">
          About Hive Index
        </Link>
        .
      </p>
    </div>
  </Layout>
)

export default GummysearchIntegrationPage
